export default "__VITE_ASSET__f3b51f96__"